import React, { useMemo } from 'react';

import classNames from 'classnames';

import { InterstellarAccount } from '../api';

interface SipTrunkSummaryProps {
  accounts: InterstellarAccount[];
  selectedAccountId?: number | null;
  onAccountSelect: (account: InterstellarAccount) => void;
}

export const SipTrunkSummary: React.FC<SipTrunkSummaryProps> = ({
  accounts,
  selectedAccountId,
  onAccountSelect,
}) => {
  const rows = useMemo(
    () => [...accounts].sort((a, b) => a.name.localeCompare(b.name)),
    [accounts]
  );

  return (
    <div className="flex h-full flex-col overflow-hidden bg-white-1.0">
      <div className="flex-1 min-h-0 overflow-auto">
        {rows.length === 0 ? (
          <div className="flex h-full items-center justify-center p-8 text-sm text-gray-2.0">
            No hay cuentas para mostrar.
          </div>
        ) : (
          <table className="w-full border-collapse">
            <thead className="sticky top-0 z-10 border-b border-white-2.0 bg-white-1.0">
              <tr>
                <th className="px-4 py-2.5 text-left text-xs font-bold uppercase tracking-wide text-gray-3.0">
                  Cuenta
                </th>
                <th className="px-4 py-2.5 text-left text-xs font-bold uppercase tracking-wide text-gray-3.0">
                  SIP Trunk
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((account) => {
                const trunk = account.sip_trunk ?? null;
                const selected = account.id === selectedAccountId;
                return (
                  <tr
                    key={account.id}
                    onClick={() => onAccountSelect(account)}
                    className={classNames(
                      'cursor-pointer border-b border-white-2.0 transition-colors',
                      selected ? 'bg-primary-2.0/10' : 'bg-white-0.0 hover:bg-white-1.0'
                    )}
                  >
                    <td className="px-4 py-3">
                      <span className="text-sm font-semibold text-black-1.0">{account.name}</span>
                    </td>
                    <td className="px-4 py-3">
                      {trunk ? (
                        <span className="font-mono text-sm font-semibold text-black-1.0">
                          {trunk}
                        </span>
                      ) : (
                        <span className="text-sm text-gray-2.0">Sin configurar</span>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};
